import React from 'react'
import Layout from '../Components/Layout/Layout'

const Policy = () => {
    return (
        <Layout>
            <h1>POLICY</h1>
        </Layout>
    )
}

export default Policy